import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    dataNewProgram: [],
    dataNewCL: [],
    userId: null
}

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setDataNewProgram: (state, action) => {
        state.dataNewProgram = action.payload;
    },
    setDataNewCL: (state, action) => {
      state.dataNewCL = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setDataNewProgram, setDataNewCL, setUserId } = notificationSlice.actions

export default notificationSlice.reducer